<template lang="pug">
  .component-policy
    .inner-content
      .row

        .column.small-1
          .field C{{item.id}}
        .column.small-1
          .field Operation:
          .field {{item.operation}}
        .column.small-6
          .field Payload:
          .field {{ JSON.stringify(item.payload)}}
        .column.small-1.statusclass
          .field Status:
          .field {{item.status}}
        .column.small-1.resultclass(v-if="type==='detail'")
          .field Result:
          .field {{JSON.stringify(item.result)}}
        .column.small-1.inputclass
          .field input:
          .field(v-if="item.input")
            a(v-on:click="openUrl(item.input)") Download
        .column.small-1
          .field Output:
          .field(v-if="item.output")
            a(v-on:click="openUrl(item.output)") Download
        .column.small-1(v-if="type!='detail'")
          .field-url-detail
            router-link(:to="{name:'cargo-operation', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action


</template>
<script type="text/babel">


  export default {
    name: "Cargo",
    components: {
    },
    data() {
      return {}
    },
    created() {

    },
    methods: {
      openUrl: function (url) {
        window.open(url, '_blank')
      },

    },
    computed: {},
    props: {
      item: '',
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
.statusclass
  padding-right: 0px!important
.inputclass
  padding-left: 30px!important
.resultclass
  padding-left: 0px!important
</style>



// WEBPACK FOOTER //
// Cargo.vue?035c3c96